module.exports = __webpack_public_path__ + "img/edgecontrol.88703ef4.svg";